import React, { ReactNode } from 'react';

import { Container, SubsectionBody, SubsectionTitle } from './styles';

interface SubsectionProps {
	children?: ReactNode;
	title?: string;
	isImportant?: boolean;
}

const Subsection = ({ title, isImportant, children }: SubsectionProps) => {
	const body = () => {
		let innerContent = children;
		if (isImportant) {
			innerContent = <b>{innerContent}</b>;
		}

		return <SubsectionBody>{innerContent}</SubsectionBody>;
	};

	return (
		<Container>
			<SubsectionTitle>{title}</SubsectionTitle>
			{body()}
		</Container>
	);
};

export default Subsection;
